import React, { useEffect } from 'react';
import { Drawer } from '@gjensidige/core-drawer';
import styles from './anbefaling-modal.module.less';
import { setBodyOverflow } from '../../../utils/view';
import { EgnethetQuestionKey } from '../../../utils/types';
import { text } from '../../../utils/text';
import { Text, Title } from '@gjensidige/core-typography';
import utils from '@gjensidige/core-utilities-css';
import { Illustration } from '../InputOptionIllustration/Illustration';
import sparehorisont from '../../../../assets/images/sparehorisont.svg';
import scale from '../../../../assets/images/scale.svg';
import speech from '../../../../assets/images/speech.svg';
import lyn from '../../../../assets/images/lyn.svg';
import { getProfilEnumName } from '../../../utils/utils';
export const AnbefalingModal = ({ visible, onClose, anbefaling }) => {
    var _a;
    useEffect(() => {
        setBodyOverflow(visible);
    }, [visible]);
    const profilEnumName = getProfilEnumName(anbefaling.risikoprofil);
    return (React.createElement(Drawer, { closable: true, visible: visible, onClick: onClose, ariaLabel: text.ANBEFALING_MODAL.ARIA_LABEL.no, ariaLabelCloseButton: text.ANBEFALING_MODAL.ARIA_LABEL_CLOSE.no, className: styles.anbefalingModal, contentClassName: styles.content, strict: false },
        React.createElement("section", { className: styles.titleSection },
            React.createElement(Title, { tag: 'h1', size: 'h5', className: styles.title }, text.ANBEFALING_MODAL.BAKGRUNN_FOR_ANBEFALING.no),
            React.createElement(Title, { tag: 'h2', size: 'h3' }, text.ANBEFALING_MODAL.VALGT_PROFIL(profilEnumName).no),
            React.createElement(Text, null, text.ANBEFALING_MODAL.BEGRUNNELSE_FORKLARING(profilEnumName).no)),
        React.createElement("section", null,
            React.createElement("ul", null, (_a = anbefaling === null || anbefaling === void 0 ? void 0 : anbefaling.begrunnelse) === null || _a === void 0 ? void 0 : _a.map((grunnTilAnbefaling) => (React.createElement("li", { key: grunnTilAnbefaling.questionKey },
                React.createElement("div", { className: styles.grunnTilAnbefaling },
                    React.createElement(Illustration, { size: 60, src: getIllustrasjon(grunnTilAnbefaling.questionKey) }),
                    React.createElement("div", null,
                        React.createElement(Text, { className: utils['font-weight-bold'] }, grunnTilAnbefaling.reason),
                        React.createElement(Text, null, grunnTilAnbefaling.answerSummary))))))))));
};
const getIllustrasjon = (key) => {
    switch (key) {
        case EgnethetQuestionKey.TIDSHORISONT:
            return sparehorisont;
        case EgnethetQuestionKey.RISIKOPREFERANSE:
            return speech;
        case EgnethetQuestionKey.RISIKO_VERDIREDUKSJON:
            return lyn;
        case EgnethetQuestionKey.RISIKO_VERDISVINGNING:
            return scale;
        default:
            return speech;
    }
};
